import mapboxgl from 'mapbox-gl';

const VALID_RESOURCE_TYPES_MARKERS = ["land", "field", "gap"];
const CLASS_PER_RESOURCE_TYPE = {
    "land": "label-land",
    "field": "label-field",
    "gap": "label-gap"
};

export class MapMarkers {

    constructor(map, parent) {
        this.map = map;
        this.parent = parent;
        this.markers = {}
    }

    init() {
        this._removeSymbolLayer();

        const added = []

        this.parent.source().get().features.forEach(feature => {
            if (VALID_RESOURCE_TYPES_MARKERS.indexOf(feature.properties.resource_type) == -1) {
                return;
            }

            let [ lng, lat ] = feature.properties.centroid;
            added.push(feature.properties.id);
            this.addMarker({
                id: feature.properties.id,
                className: CLASS_PER_RESOURCE_TYPE[feature.properties.resource_type],
                lng,
                lat,
                textContent: feature.properties.name
            });
        });

        Object.keys(this.markers).forEach(key => {
            if (added.indexOf(key) === -1) {
                this.deleteMarker(key);
            }
        })

        this.handleZoom()();
    }

    deleteMarker(id) {
        if (!this.markers[id]) {
            return
        }
        this.markers[id].marker.remove();
        delete this.markers[id];
    }

    hide(id) {
        if (!this.markers) {
            setTimeout(() => this.hide(id), 100);
            return
        }

        if (!this.markers[id]) {
            return
        }

        this.markers[id].container.style.visibility = "hidden";
    }

    show(id) {
        if (!this.markers) {
            setTimeout(() => this.show(id), 100);
            return
        }

        if (!this.markers[id]) {
            return
        }
        
        this.markers[id].container.style.visibility = "visible";
    }

    reload() {
        this.init();
    }

    addMarker({ id, className, lng, lat, popup, textContent }) {
        if (this.markers[id]) {
            this.markers[id].container.textContent = textContent;
            return;
        }

        const markerId = this._getMarkerId(id);
        var container = document.createElement('div');
        container.setAttribute("id", markerId);
        container.textContent = textContent;
        container.className = className;

        let marker = new mapboxgl.Marker(container)
            .setLngLat([lng, lat]);

        if (popup) {
            marker = marker.setPopup(popup);
        }

        marker = marker.addTo(this.map);
        this.markers[id] = { marker, container};
    }

    changeStyle(cls, display){
        const el = document.getElementsByClassName(cls);
        for (var i = 0; i < el.length; i++) {
            if (el[i].hasAttribute('ignore')) {
                continue;
            }

            el[i].style.display = display;
        }
    };

    handleZoom() {
        const $this = this;
        return () => {
            const zoom = $this.map.getZoom();

            if (zoom < 11) {
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.land, 'none');
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.field, 'inline-flex');
            } else {
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.land, 'inline-flex');
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.field, 'none');
            }

            if (zoom > 14) {
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.gap, 'inline-flex');
            } else {
                $this.changeStyle(CLASS_PER_RESOURCE_TYPE.gap, 'none');
            }
        };
    }

    _removeSymbolLayer() {
        if (this.map.getLayer('markers')) {
            this.map.removeLayer('markers');
        }

        if (this.map.getSource('markers')) {
            this.map.removeSource('markers');
        }
    }
        
    _getMarkerId(id) {
        return "marker-" + id;
    }
}
